import useAxios from 'hooks/useAxios';

export async function setAffiliateCodeOwner(codeId, userId) {
  const api = useAxios();

  try {
    const res = await api.patch(`/users/affiliate-codes/${codeId}/owner`, {
      userId: userId || null,
    });
    return res;
  } catch (err) {
    return err;
  }
}

